export default __webpack_public_path__ + "static/media/Aparna Agrawal.ae82a064.jpg";